import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import { Anchor } from 'antd'
import { observer } from 'mobx-react'
import { hot } from 'react-hot-loader/root'
import Store, { AppStore } from 'src/pc/store/AppStore'
import homeIconImg from 'src/pc/assets/images/activity/23-6-16/home-icon.png'
import styled from '@emotion/styled'
import classNames from 'classnames'

const HomeIcon: FunctionComponent = () => {
  if (!AppStore['activity-23-6-16']) {
    return null
  }
  return (
    <StyledHomeIconContainer
      onClick={() => {
        AppStore['activity-23-6-16'] && (AppStore['activity-23-6-16'].modalVisible = true)
        window.sensorsdataReportParams?.('BoxClient_HPRecommend_External_Click', {})
      }}
    >
      <img src={homeIconImg} />
      <div className="last-main">
        {AppStore['activity-23-6-16']?.timeText.hours}:{AppStore['activity-23-6-16']?.timeText.minutes}:
        {AppStore['activity-23-6-16']?.timeText.seconds}
      </div>
    </StyledHomeIconContainer>
  )
}

const StyledHomeIconContainer = styled.div`
  width: 86px;
  border-radius: 8px 8px 8px 8px;
  position: absolute;
  left: 0px;
  top: 50%;
  margin-top: -316px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  .last-main {
    text-align: center;
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #fd4747;
    line-height: 17px;
  }
`
export default hot(observer(HomeIcon))
export const ActivityHomeIcon = hot(observer(HomeIcon))
